module.exports = __webpack_public_path__ + "img/01.abe0f86e.jpg";